import React from 'react';
import getCommentsByBlog from '../../api/getCommentsFor';
import postComments from '../../api/postComment';
import './BlogComments.css';


export default class BlogComments extends React.Component {
  state ={
    comments:[],
    commentAuthor:"",
    commentBox:""
  }

  async setBlogComments() {
    const commentsInfo = await getCommentsByBlog(this.props.blogId);

    if(commentsInfo.status === 200)
      this.setState({ comments: commentsInfo.comments})
  }

  handleMadeComment = () => {
    if(this.state.commentAuthor !== "" && this.state.commentBox !== "") {
      postComments(this.state.commentAuthor,
        this.state.commentBox,
        this.props.blogId
      )
      .then(() => {
        this.setBlogComments();
        this.setState({
          commentAuthor:"",
          commentBox:""
        })
      });
    }
  }

  handleInputChange= (event) => {
    this.setState(
      {
        [event.target.name]:event.target.value
      }
    )
  }

  componentDidMount() {
    this.setBlogComments()
  }

  render() {
    return (
      <section className="blog-comments">
        <div className="comments"> 
          { 
            this.state.comments.length > 0 
            ? this.state.comments.map((comment) => {
              return(
                <div key={comment.id} className="comment">
                  <div>{comment.name}</div>
                  <div>{comment.content}</div>
                  <div>{new Date(comment.dateSent).toDateString()}</div>
                </div>
              )
            })
            : <div>Not comments yet.</div>
            
          }
        </div>

        <div> 
          <input
            onChange={(e)=> this.handleInputChange(e)}
            type="text" name="commentAuthor"
            className="comment-author"
            value={this.state.commentAuthor}
            placeholder="Please enter your name"
          />
          <textarea
            onChange={(e)=> this.handleInputChange(e)}
            name="commentBox"
            className="comment-box"
            cols="30"
            rows="10"
            value={this.state.commentBox}
            placeholder="Please write your thoughts here"
          ></textarea>
          <button onClick={this.handleMadeComment}>Comment</button>
        </div>
        
      </section>
    )
  }
}